export enum TabLabel {
  AllRequests = 'AllRequests',
  AllCustomers = 'AllCustomers',
  CompanyInfo = 'CompanyInfo',
  Contract = 'Contract',
  MadarContract = 'MadarContract',
  CustomerFleetContracts = 'CustomerFleetContracts',
  Trucks = 'Trucks',
  Vehicles = 'Vehicles',
  RentedTrucks = 'RentedTrucks',
  RentalVehicles = 'RentalVehicles',
  Drivers = 'Drivers',
  Trailers = 'Trailers',
  Users = 'Users',
  Receivers = 'Receivers',
  AllProviders = 'AllProviders',
  DriversTracking = 'DriversTracking',
  MobileTracking = 'MobileTracking',
  AVLTracking = 'AVLTracking',
  DriversPool = 'DriversPool',
  ShipmentTracking = 'ShipmentTracking',
  FleetConfiguration = 'FleetConfiguration',
  Online = 'Online',
  Offline = 'Offline',
  Shipments = 'Shipments',
  Payments = 'Payments',
  CustomerConfiguration = 'CustomerConfiguration',
  ShipmentConfiguration = 'ShipmentConfiguration',
  LocalVatType = 'LocalVatType',
  ExportVatType = 'ExportVatType',
  SisterCompanyVatType = 'SisterCompanyVatType',
  FleetB2cInfo = 'FleetB2cInfo',
  GlobalSpecificConracts = 'GlobalSpecificConracts',
  GlobalConract = 'GlobalConract',
  MyCustomers = 'MyCustomers',
  Configuration = 'Configuration',
  Financial = 'Financial',
  Transactions = 'Transactions',
  DaleelTracking = 'DaleelTracking',
  OrganizationConfiguration = 'OrganizationConfiguration',
  Statements = 'Statements',
}
